import { Mapper } from './base-mapper';
import { Mosaic, MosaicItem } from '@/core/domain/mosaic';
import { GetMosaicResponseDTO, MosaicItemDTO, MosaicEntity } from '@/core/dto/dashboard';

export class MosaicFindAllMapper extends Mapper<Mosaic> {
	private readonly rows: MosaicItemDTO[];
	private readonly entity: MosaicEntity;
	private readonly limit: number;
	private readonly offset: number;
	private readonly total: number;

	constructor({ rows, entity, limit, offset, total }: GetMosaicResponseDTO) {
		super();
		this.rows = rows;
		this.entity = entity;
		this.limit = limit;
		this.offset = offset;
		this.total = total;
	}

	toTransformItem(parameters: MosaicItemDTO): MosaicItem {
		return new MosaicItem(parameters);
	}

	toDomain(): Mosaic {
		return {
			rows: this.rows.map(this.toTransformItem.bind(this)),
			entity: this.entity,
			limit: this.limit,
			offset: this.offset,
			total: this.total
		};
	}
}
